import type mitt from 'mitt';
import { inject } from 'vue';

/**
  TODO:
 Это промежуточный вариант.
 Про интерфейс FlowEvents - лично мне бы очень хотелось, чтобы это жило на слоях выше,
 но пока опять же я уперся в то, что это должно полежать здесь.
 */

interface LoadingEventPayload {
  request: () => Promise<any>;
  requestId: string | 'request';
  withLoader?: boolean;
  withError?: boolean;
  infinityLoader?: boolean;
  // TODO: удалить isFirstLoader когда обновим первый экран загрузки
  isFirstLoader?: boolean;
}

export interface FlowEvents extends Record<string | symbol, unknown> {
  loading: LoadingEventPayload;
  showOverdueStyle: boolean;
}

export function useFlowEventEmitter() {
  const eventEmitter = inject<ReturnType<typeof mitt<FlowEvents>>>('eventEmitter');
  if (!eventEmitter) throw new Error('eventEmitter not initialized!');
  return eventEmitter;
}

export function useFlowLoadingEmitter() {
  const eventEmitter = useFlowEventEmitter();
  return (request: () => Promise<any>, isFirstLoader: boolean = false) =>
    eventEmitter.emit('loading', {
      request,
      requestId: btoa(request.toString().slice(0, 30)),
      isFirstLoader,
    });
}
